export default function timeStampToDate(timestamp){
    let options = {year: '2-digit', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone:'UTC'};
    return new Date((timestamp) * 1000).toLocaleDateString('fr-FR', options);
}
